/** @jsx jsx */
import { Link } from 'gatsby'
import { jsx } from 'theme-ui'
import PropTypes from 'prop-types'
import { useAnalytics } from '@chordcommerce/gatsby-theme-autonomy'
import { useCatalog } from '~/hooks/components/use-catalog'
import { getViewedProductFromSlug } from '~/utils/products'

const ProductLink = ({ slug, slugUrl, children, sx, ...props }) => {
  const { trackProductClicked } = useAnalytics()
  const { catalog } = useCatalog()

  const url = `/products/${slugUrl || slug}/`
  const product = getViewedProductFromSlug(catalog, slug)

  return (
    <Link
      to={url}
      onClick={() => trackProductClicked({ product })}
      sx={{
        ...sx,
      }}
      {...props}
    >
      {children}
    </Link>
  )
}

ProductLink.propTypes = {
  slug: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default ProductLink
